import { articles } from '@/mocks/articles';
import ArticleLayout from '@/pages/article/components/ArticleLayout';

export default function ArticleTutorial() {
  const article = articles.find((a) => a.slug === 'come-usare-itaobuy-spreadsheet')!;
  return <ArticleLayout article={article} />;
}